'use client';

import logger from '@/utils/client-logger';
import Image from '@/components/Image';
import { useEffect } from 'react';

interface CandyNavProps {
  pageData: any;
}

export default function CandyNav({ pageData }: CandyNavProps) {
  const list = pageData?.product?.list || [];

  useEffect(() => {
    if (pageData && Object.keys(pageData).length > 0 && list.length > 0) {
      // 延迟初始化，确保DOM完全渲染
      const initTimer = setTimeout(() => {
        const navItems = document.querySelectorAll('.nav-list ul li');
        if (navItems.length > 0) {
          navItems.forEach((el, index) => {
            setTimeout(
              () => {
                el.classList.add('fadeInRightAnimate');
                logger.log(`Added animation to nav item ${index}`);
              },
              200 * (index + 1),
            );
          });
        } else {
          // 如果找不到导航项，稍后再试
          setTimeout(() => {
            const navItems2 = document.querySelectorAll('.nav-list ul li');
            navItems2.forEach((el, index) => {
              setTimeout(
                () => {
                  el.classList.add('fadeInRightAnimate');
                  logger.log(`Force added animation to nav item ${index}`);
                },
                200 * (index + 1),
              );
            });
          }, 1000);
        }
      }, 1500);

      return () => clearTimeout(initTimer);
    }
  }, [pageData, list]);

  const handleNavClick = () => {
    const el = document.getElementById('candyList');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!list.length) return null;

  return (
    <div className="nav-list w-full pt-[30px] md:pt-[40px] xl:pt-[51px] px-[15px] md:px-[20px] lg:px-[25px] xl:px-[30px] bg-white h-full">
      <ul className="flex flex-col items-center justify-start">
        {list.map((item: any, index: number) => (
          <li
            key={index}
            className="opacity0 mb-[20px] md:mb-[25px] lg:mb-[28px] xl:mb-[30px] 2xl:mb-[32px] last:mb-0 cursor-pointer relative group"
            onClick={handleNavClick}
          >
            <Image
              src={item.nav_image}
              alt={`${item.short_name || item.name} glasses ${index + 1}`}
              width={450}
              height={300}
              className="w-[200px] md:w-[300px] lg:w-[350px] xl:w-[400px] 2xl:w-[480px] h-auto transition-opacity duration-300"
            />
            <Image
              src={item.nav_hover_image}
              alt={`${item.short_name || item.name} glasses ${index + 1}`}
              width={450}
              height={300}
              className="w-[200px] md:w-[300px] lg:w-[350px] xl:w-[400px] 2xl:w-[480px] h-auto absolute top-0 left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 object-contain"
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
